.wrap {
  user-select: none;
  margin-bottom: 4px;
}

.labels {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.labelBadge {
  background: var(--blue-lt);
  color: var(--blue);
  border: 1px solid var(--blue-mid);
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 13.5px;
  font-weight: 600;
  font-family: 'Google Sans', sans-serif;
}

.labelArrow {
  color: var(--muted2);
  font-size: 14px;
}

.duration {
  margin-left: auto;
  font-size: 12.5px;
  color: var(--muted2);
  font-weight: 500;
}

.trackWrap {
  position: relative;
  height: 28px;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0 10px;
}

.track {
  position: absolute;
  left: 0; right: 0;
  height: 6px;
  background: var(--border);
  border-radius: 6px;
}

.fill {
  position: absolute;
  height: 6px;
  background: var(--blue);
  border-radius: 6px;
  pointer-events: none;
}

.thumb {
  position: absolute;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: white;
  border: 2.5px solid var(--blue);
  box-shadow: 0 1px 4px rgba(26,115,232,.3), var(--shadow-sm);
  transform: translateX(-50%);
  cursor: grab;
  transition: box-shadow .15s, transform .1s;
  z-index: 2;
}

.thumb:hover {
  box-shadow: 0 2px 8px rgba(26,115,232,.4), var(--shadow);
  transform: translateX(-50%) scale(1.12);
}

.thumb:active { cursor: grabbing; }

.ticks {
  position: relative;
  height: 18px;
  margin: 6px 10px 0;
}

.tick {
  position: absolute;
  transform: translateX(-50%);
  font-size: 11px;
  color: var(--muted2);
  white-space: nowrap;
}
